import addUrlParam from './addUrlParam';



export const setUrlParams = (params) => window.history.replaceState({}, '', `${location.pathname}?${addUrlParam(params)}`);
